import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';

const browserHistory = createBrowserHistory();
const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: process.env.REACT_APP_APPInsights,
        enableCorsCorrelation: true,
        correlationHeaderExcludedDomains: [
            '*.doubleclick.net',
            '*.google-analytics.com',
            '*.hotjar.io',
            '*.googletagmanager.com',
            '*.optimizely.com'
        ],
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory },
    },
  },
});
appInsights.loadAppInsights();
appInsights.addTelemetryInitializer((envelope) => {
  if(envelope.baseData){
    var telemetryItem = envelope.baseData;

    if(telemetryItem.name){
      var nameString = telemetryItem.name as string;

      // password
      if(nameString.includes("password")){
        var nameIndex = nameString.indexOf("&password=");
        telemetryItem.name =
          nameString.substring(0, nameIndex) + '&password=****';
      }
      
      // mobile OTP
      if(nameString.includes("smsVerificationCode")){
        nameIndex = nameString.indexOf("&smsVerificationCode=");
        telemetryItem.name =
          nameString.substring(0, nameIndex) + '&smsVerificationCode=****';
      }
    }
    
    if(telemetryItem.target){
      var targetString = telemetryItem.target as string;

      // password
      if(targetString.includes("password")){
        var targetIndex = targetString.indexOf("&password=");
        telemetryItem.target =
          targetString.substring(0, targetIndex) + '&password=****';
      }

      // mobile OTP
      if(targetString.includes("smsVerificationCode")){
        targetIndex = targetString.indexOf("&smsVerificationCode=");
        telemetryItem.target =
          targetString.substring(0, targetIndex) + '&smsVerificationCode=****';
      }
    }
  }
});
export { reactPlugin, appInsights };
